import { BreakpointKey } from '../utils/useBreakpointTokens';
import { useBreakpointContext } from './useBreakpointContext';

export function useMatchedBreakpoints(): ['base', ...BreakpointKey[]] {
  const context = useBreakpointContext();
  return (
    (context?.matchedBreakpoints as ['base', ...BreakpointKey[]]) || ['base']
  );
}
